import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import { useParams } from 'react-router-dom'
import tinycolor from 'tinycolor2'
import Title from 'src/apps/CustomApp/components/Title'
import UserBadgeSash from 'src/apps/People/components/UserBadgeSash'
import { useUser } from 'src/graphql/hooks'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'
import ProfileActions from '~/components/Actions'

const ProfileAboutBlock = () => {
   const { userId } = useParams()
   const { protoTheme: theme } = useContext(ProtoThemeContext)
   const { user } = useUser({ id: userId })

   const avatarUrl = user.avatarMedia
      ? user.avatarMedia?.file.thumbnailUrlW240
      : '/assets/images/avatarPlaceholder.svg'

   return (
      <View
         flexFlow="column"
         paddingVertical="50px[a-c] 50px[d-f]"
         height="100%[d-f]">
         <View flex="1 1 auto">
            <View
               display="flex"
               flexFlow="row-reverse"
               width="100%">
               <View
                  flex="0 0 auto"
                  width="70px[a-b] 90px[c] 60px[d-f]"
                  height="70px[a-b] 90px[c] 60px[d-f]"
                  marginBottom="30px[d-f]"
                  borderRadius="5px"
                  backgroundColor="#eee"
                  backgroundImage={`url(${avatarUrl})`}
                  backgroundSize={user.avatarMedia ? 'cover' : '90% 90%'}
                  backgroundPosition="bottom center"
                  backgroundRepeat="no-repeat"
               />
               <View
                  flex="1 1 auto"
                  width="100%"
                  paddingRight="20px[a-d]">
                  <Title size="xl">
                     {user.fullName}
                  </Title>
                  <View marginTop="5px" opacity="0.5">
                     <Text size="2.5" color={theme.tmpTitleColor}>
                        {user.position}
                        {user.position && user.organization && ', '}
                        {user.organization}
                     </Text>
                  </View>
                  <UserBadgeSash
                     badges={user.badges}
                     size="lg"
                     style={{ margin: '15px 0 0 0' }}
                  />
               </View>
            </View>
            {(user.bio || user.skills.length > 0 || user.certifications.length > 0) && (
               <View
                  marginTop="20px"
                  width="100%"
                  borderTop={`1px solid ${theme.tmpContentLineColor}`}
               />
            )}
            {user.bio && (
               <View maxWidth="650px" marginTop="20px" opacity="0.5">
                  <Text size="2.5" color={theme.tmpTitleColor} lineHeight="150%">
                     {user.bio}
                  </Text>
               </View>
            )}
            {user.skills.length > 0 && (
               <View
                  width="100%"
                  paddingTop="20px[a-d] 30px[e-f]">
                  <Text
                     size="2[a-b] 3[c-f]"
                     weight="medium"
                     color={theme.tmpTitleColor}>
                     Skills
                  </Text>
                  <View maxWidth="650px" marginTop="10px" opacity="0.5">
                     {user.skills.map(skill => (
                        <View
                           key={skill}
                           display="inline-flex"
                           alignItems="center"
                           height="25px"
                           padding="0px 10px"
                           borderRadius="2px"
                           marginRight="10px"
                           marginBottom="10px"
                           backgroundColor={tinycolor(theme.tmpTitleColor).setAlpha(0.1)}>
                           <Text size="2" color={theme.tmpTitleColor}>{skill}</Text>
                        </View>
                     ))}
                  </View>
               </View>
            )}
            {user.certifications.length > 0 && (
               <View
                  width="100%"
                  marginTop="20px[a-d] 30px[e-f]">
                  <Text
                     size="2[a-d] 3[e-f]"
                     weight="medium"
                     color={theme.tmpTitleColor}>
                     Certifications
                  </Text>
                  <View maxWidth="650px" marginTop="10px" opacity="0.5">
                     {user.certifications.map(certification => (
                        <View
                           key={certification}
                           display="inline-flex"
                           alignItems="center"
                           height="25px"
                           padding="0px 10px"
                           borderRadius="2px"
                           marginRight="10px"
                           marginBottom="10px"
                           backgroundColor={tinycolor(theme.tmpTitleColor).setAlpha(0.1)}>
                           <Text size="2" color={theme.tmpTitleColor}>{certification}</Text>
                        </View>
                     ))}
                  </View>
               </View>
            )}
         </View>
         <View
            flex="0 0 auto"
            maxWidth="350px"
            display="flex"
            marginTop="20px">
            <ProfileActions />
         </View>
      </View>
   )
}

export default ProfileAboutBlock
